module.exports = __webpack_public_path__ + "pnskfsquadron/img/book-weapon2.png?9c0b3477";